<div class="header-container">
  <h2 class="ml-2" style="margin-bottom: 0;">Escalation Matrix</h2>
</div>
<div class="container-fluid escalation-container">
  <div class="row">
    <!-- Left Section -->
    <div class="col-lg-8 col-md-7 col-sm-12 escalation-left">
      <table class="table escalation-table">
        <thead>
          <tr>
            <th style="width:15%">Escalation Level</th>
            <th style="width:25%">Level 1: Email to Support</th>
            <th style="width:33%">Level 2: Zonal SPOC</th>
            <th>Level 3: Shivam Gupta (National SPOC)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="background: #eaf4ff;">Action</td>
            <td>Share issue with details/screenshots</td>
            <td>If not resolved or no update provided.</td>
            <td>If unresolved at Zonal SPOC level</td>
          </tr>
          <tr>
            <td style="background: #eaf4ff;">TAT</td>
            <td>4 – 24 Business Hours (Based on scenarios)</td>
            <td>+1 Working Day</td>
            <td>+1 Working Day</td>
          </tr>
          <tr>
            <td style="background: #eaf4ff;">Platform: GMB, Website, LMS, Social, Virtual Number (VN)</td>
            <td>
              <a [href]="gmailLink('support.suzukihyperlocal@adglobal360.com')" target="_blank" rel="noopener">
                support.suzukihyperlocal&#64;adglobal360.com
              </a>
            </td>
            <td>
              <strong>North –</strong> Mr. Jagdish Kumar <br />
              <a [href]="gmailLink('jagdish.kumar@adglobal360.com')" target="_blank" rel="noopener">
                jagdish.kumar&#64;adglobal360.com
              </a><br />
              <strong>East –</strong> Ms. Muskan Vashisth <br />
              <a [href]="gmailLink('muskan.vashisth@adglobal360.com')" target="_blank" rel="noopener">
                muskan.vashisth&#64;adglobal360.com
              </a><br />
              <strong>West –</strong> Ms. Nikita Digani <br />
              <a [href]="gmailLink('nikita.digani@adglobal360.com')" target="_blank" rel="noopener">
                nikita.digani&#64;adglobal360.com
              </a><br />
              <strong>South 1 –</strong> Mr. Karan Bisht <br />
              <a [href]="gmailLink('karan.bisht1@adglobal360.com')" target="_blank" rel="noopener">
                karan.bisht1&#64;adglobal360.com 
              </a><br />
              <strong>South 2 –</strong> Ms. Shreya Pal <br />
              <a [href]="gmailLink('shreya.pal@adglobal360.com')" target="_blank" rel="noopener">
                shreya.pal&#64;adglobal360.com
              </a>
            </td>
            <td>
              Mr. Shivam Gupta <br />
              <a [href]="gmailLink('shivam.gupta@adglobal360.com')" target="_blank" rel="noopener">
                shivam.gupta&#64;adglobal360.com
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <div class="card card-plain mb-3">
          <div class="card-header py-2 fw-semibold">How to Raise Tickets:</div>
          <div class="card-body">
            <ul class="mb-0">
              <li>Send an email to support email ID -
                <strong>support.suzukihyperlocal&#64;adglobal360.com</strong>
              </li>
              <li>Use the email ids with domain <strong>&#64;suzukidealers.in</strong> for sending tickets</li>
              <li>Subject line format: <strong>[Outlet Code] [Priority] - [WEBSITE/LMS/GMB/SOCIAL, VN]</strong></li>
              <li>Support team available <strong>Monday to Friday, 09:30 AM - 6:30 PM</strong></li>
            </ul>
          </div>
        </div>


        <!-- Important Pointers -->
        <div class="card card-plain">
          <div class="card-header py-2 fw-semibold">Important Pointers:</div>
          <div class="card-body">
            <ul class="mb-0">
              <li>Raise one issue per ticket for better tracking.</li>
              <li>All tickets must start at Level 1; escalate to Level 2 or 3 only if unresolved within the defined TAT
                as per the escalation matrix.</li>
              <li>Track ticket status via email looping support id.</li>
              <li>Final resolution will be shared via email once the issue is resolved.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Right Section -->
    <div class="col-lg-4 col-md-5 col-sm-12 escalation-right">
      <!-- View Activity Section -->
      <div class="view-activity" (click)="openTatModal()">
        <span>View Activity & Resolution Time Breakdown</span>
        <i class="bi bi-info-circle-fill info-icon" [tooltip]="activityInfo" container="body" placement="left"
          [adaptivePosition]="false" containerClass="tooltipContainer"></i>
      </div>
      <ng-template #activityInfo>
        View a detailed breakdown of resolution times for activities.
      </ng-template>

      <!-- Tutorials Section -->
      <div class="tutorials-box mt-3">
        <h6 style="font-size: 14px; margin-bottom: 0px;" class="fw-bold">
          Tutorials
          <!-- <i class="bi bi-info-circle ms-1" [tooltip]="tooltipTemplate" container="body" placement="top"
            [adaptivePosition]="false" containerClass="tooltipContainer">
          </i> -->
        </h6>

        <ng-template #tooltipTemplate>
          These tutorials provide step-by-step guide for our application and services.
        </ng-template>

        <div class="table-responsive">
          <table class="table tutorials-table">
            <thead>
              <tr>
                <th>Tutorial Name</th>
                <th>Last Updated</th>
                <th style="text-align: center;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dealer Sales Executive Application <span><img class="info" src="/assets/images/info.png" alt=""
                      [adaptivePosition]="false" container="body" placement="top" containerClass="tooltipContainer"
                      [tooltip]="dse"></span> </td>
                <ng-template #dse>This tutorial provides a step by step guide to use DSE Mobile Application.
                </ng-template>
                <td style="font-size: 10px;">Mar 02, 2026</td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <img src="/assets/images/support-download.png" alt=""
                      style="width: 18px; height: 18px;cursor: pointer;"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Updated+DSE_Training_User+Guide+(190226).pdf')">
                    <a href="javascript:void(0)"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Updated+DSE_Training_User+Guide+(190226).pdf')">
                      Download
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Digital Desk Application <span><img class="info" src="/assets/images/info.png" alt=""
                      [adaptivePosition]="false" container="body" placement="top" containerClass="tooltipContainer"
                      [tooltip]="dd"></span></td>
                <ng-template #dd>This tutorial provides a step by step guide to use Digital Desk Application.
                </ng-template>
                <td style="font-size: 10px;">Sep 17, 2026</td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <img src="/assets/images/support-download.png" alt=""
                      style="width: 18px; height: 18px;cursor: pointer;"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Digital+Desk_Training_User+Guide_Final.pdf')">
                    <a href="javascript:void(0)"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Digital+Desk_Training_User+Guide_Final.pdf')">
                      Download
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Facebook & Google Ads Setup <span><img class="info" src="/assets/images/info.png" alt=""
                      [adaptivePosition]="false" container="body" placement="top" containerClass="tooltipContainer"
                      [tooltip]="fb"></span></td>
                <ng-template #fb>This tutorial offers a step-by-step guide to setting up and running Facebook and Google ads, along with seamless integration of LMS.
                </ng-template>
                <td style="font-size: 10px;">Oct 07, 2025</td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <img src="/assets/images/support-download.png" alt=""
                      style="width: 18px; height: 18px;cursor: pointer;"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Paid Media Approach for Facebook & Google.pdf')">
                    <a href="javascript:void(0)"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Paid Media Approach for Facebook & Google.pdf')">
                      Download
                    </a>
                  </div> 
                </td>
              </tr>
                <tr>
                <td>Socionix & Geobiz <span><img class="info" src="/assets/images/info.png" alt=""
                      [adaptivePosition]="false" container="body" placement="top" containerClass="tooltipContainer"
                      [tooltip]="socionix"></span></td>
                <ng-template #socionix>
                  This tutorial offers a demonstration of the Socionix and Geobiz tool, highlighting their features for efficiently managing social media posts and Google My Business (GMB) listings.
                </ng-template>
                <td style="font-size: 10px;">Oct 07, 2025</td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <img src="/assets/images/support-download.png" alt=""
                      style="width: 18px; height: 18px;cursor: pointer;"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Socionix & Geobiz Tool Guide.pdf')">
                    <a href="javascript:void(0)"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Socionix & Geobiz Tool Guide.pdf')">
                      Download
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Quotation Sharing - DSE Appilication <span><img class="info" src="/assets/images/info.png" alt=""
                      [adaptivePosition]="false" container="body" placement="top" containerClass="tooltipContainer"
                      [tooltip]="quotation"></span></td>
                <ng-template #quotation>
                  This tutorial provided the step by step guide to create and share the Quotation in the DSE (Dealer Sales Executive) application.
                </ng-template>
                <td style="font-size: 10px;">Feb 13, 2026</td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <img src="/assets/images/support-download.png" alt=""
                      style="width: 18px; height: 18px;cursor: pointer;"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Quotation+Tutorial.pdf')">
                    <a href="javascript:void(0)"
                      (click)="downloadFile('https://d1sn8rvxrcf2ob.cloudfront.net/assets/Quotation+Tutorial.pdf')">
                      Download
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #tatModal>
  <h4 mat-dialog-title class="dialog-title">
    <span class="dialog-text">Support Ticket Scenario Example Estimated TAT</span>
    <div class="dialog-right">
      <img [src]="bucketurl + '/images/suzuki_logo.png'" class="logo" alt />
      <img class="close-button" mat-dialog-close src="/assets/images/close.png" alt="" (click)="closeDialog()">
    </div>
  </h4>


  <mat-dialog-content>
    <div class="modal-content tat-modal">
      <!-- Body -->
      <div class="modal-body">
        <table class="table  table-bordered  tat-table">
          <thead>
            <tr>
              <th>Service</th>
              <th>Ticket Type Examples</th>
              <th>Estimated TAT</th>
            </tr>
          </thead>
          <tbody>
            <!-- GMB -->
            <tr>
              <td rowspan="4"
                style="text-align: center;border-bottom: 1px solid black;border-left: 1px solid black;;border-right: 1px solid black;">
                <strong>GMB</strong>
              </td>
              <td style="border-right: 1px solid black;">1. Business info update (address, hours, phone) not reflecting.
              </td>
              <td style="border-right: 1px solid black;">Google approval typically takes up to 3 days, but can sometimes
                extend to 30 days.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">2. Negative reviews needing escalation</td>
              <td style="border-right: 1px solid black;">16 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">3. GMB access request or ownership transfer</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">4. Photos/posts not showing on
                profile</td>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">24 Hrs. <br><small>(Might differ
                  if pending from Google’s end)</small></td>
            </tr>

            <!-- Website -->
            <tr>
              <td rowspan="7"
                style="text-align: center;border-bottom: 1px solid black;border-left: 1px solid black;;border-right: 1px solid black;">
                <strong>Website</strong>
              </td>
              <td style="border-right: 1px solid black;">1. Website down / not loading</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">2. SSL certificate expired or browser warning</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">3. Broken links or 404 error pages although website is loading
              </td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">4. Content/image update requests</td>
              <td style="border-right: 1px solid black;">24 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">5. One of the form not working or not capturing leads</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">6. Slow website speed / high bounce rate</td>
              <td style="border-right: 1px solid black;">24 Hrs.</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">7. Tracking code (GA, Meta
                Pixel) not firing</td>
              <td style="border-bottom: 1px solid black;border-right:1px solid black">8 Hrs.</td>
            </tr>

            <!-- LMS -->
            <tr>
              <td rowspan="7"
                style="text-align: center;border-bottom: 1px solid black;border-left: 1px solid black;;border-right: 1px solid black;">
                <strong>LMS</strong>
              </td>
              <td style="border-right: 1px solid black;">1. User unable to log in</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">2. Leads not visible or app crashing for field agents</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">3. System not filtering based on mobile/email</td>
              <td style="border-right: 1px solid black;">24 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">4. Mismatch between actual source and system input</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">5. Auto-routing to incorrect team/member</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">6. Lead status not changing after actions</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">7. Report download errors</td>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">16 Hrs.</td>
            </tr>
            <!-- Social -->
            <tr>
              <td rowspan="5"
                style="text-align: center;border-bottom: 1px solid black;border-left: 1px solid black;;border-right: 1px solid black;">
                <strong>Social</strong>
              </td>
              <td style="border-right: 1px solid black;">1. Posting of dealer 1 showing on page of dealer 2</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">2. Festival post not posted</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">3. Unable to share post via tool</td>
              <td style="border-right: 1px solid black;">8 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">4. Post not approved or rejected due to policy</td>
              <td style="border-right: 1px solid black;">24 Hrs.</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">5. Business Manager access issue
              </td>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">24 Hrs.</td>
            </tr>

            <!-- Virtual Number -->
            <tr>
              <td rowspan="7"
                style="text-align: center;border-bottom: 1px solid black;border-left: 1px solid black;;border-right: 1px solid black;">
                <strong>Virtual Number</strong>
              </td>
              <td style="border-right: 1px solid black;">1. Call not connecting to virtual number</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">2. Call recording not available</td>
              <td style="border-right: 1px solid black;">16 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">3. Missed calls not logging in CRM</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">4. VN not routing to correct department</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">5. Caller hears wrong or outdated greeting</td>
              <td style="border-right: 1px solid black;">16 Hrs.</td>
            </tr>
            <tr>
              <td style="border-right: 1px solid black;">6. Call forwarding not working properly</td>
              <td style="border-right: 1px solid black;">4 Hrs.</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">7. Integration with CRM not
                syncing properly</td>
              <td style="border-bottom: 1px solid black;border-right: 1px solid black;">8 Hrs.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>
